import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sync-warning-msg',
  templateUrl: './sync-warning-msg.component.html',
  styleUrls: ['./sync-warning-msg.component.scss'],
})
export class SyncWarningMsgComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
